import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeAccessory } from '../../redux/actions/accessories';

interface Props {
  match: any;
  handleRemoveAccessory: Function;
}

const Route = ({ match, handleRemoveAccessory }: Props) => (
  <RouteWrapper
    title="Remove Accessory"
    requireAuth
    requirePermission="MANAGE_ACCESSORIES"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Accessory?</Title>
      <Subtitle>
        <p>
          Once this accessory is removed, you will not be able to add it to
          bookings anymore.
        </p>
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveAccessory(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Accessory
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/settings/accessories/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveAccessory: (id) => {
    dispatch(removeAccessory(id)).then((response) => {
      if (!response.error) {
        dispatch(goBack());
        dispatch(goBack());
      } else {
        dispatch(goBack());
      }
    });
  },
});

export default connect(() => ({}), mapDispatchToProps)(Route);
